<template>
    <div data-dusk="authorization">
        <modal
            title="Add Funds Authorization"
            v-show="show"
            :okClass="confirmButtonClass"
            okText="Confirm"
            cancelClass="btn btn-link"
            @ok="save"
            @cancel="cancel"
            >
            <p class="m-b-lg">
                Click the Confirm button below to charge your card and we will update your account balance within 24 hours. If you have any questions or if your account balance is incorrect, contact your account manager or <a href="mailto:support@bankrate.com">support@bankrate.com</a>
            </p>

            <validation-errors :errors="errors"></validation-errors>

            <div class="row" data-dusk="ready">
                <div class="col-md-12">

                    <table class="table table-responsive table-condensed table-bordered" v-if="showConvenienceFee()">
                        <tbody>
                            <tr>
                                <td><strong>Product Category</strong></td>
                                <td>{{ fundsPool.name }}</td>
                            </tr>
                            <tr>
                                <td><strong>Funding Source</strong></td>
                                <td><card-preview :funding-source="fundingSource"></card-preview></td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>Amount</strong>
                                    <br />
                                    <strong>Convenience Fee</strong>
                                </td>
                                <td>
                                    {{ amount }}.00
                                    <br />
                                    $ {{ fee | currency }}
                                </td>
                            </tr>
                            <tr>
                                <td><strong>Total Amount</strong></td>
                                <td>$ {{ totalAmount | currency }}</td>
                            </tr>
                        </tbody>
                    </table>

                    <table class="table table-responsive table-condensed table-bordered" v-else>
                        <tbody>
                        <tr>
                            <td><strong>Product Category</strong></td>
                            <td>{{ fundsPool.name }}</td>
                        </tr>
                        <tr>
                            <td><strong>Funding Source</strong></td>
                            <td><card-preview :funding-source="fundingSource"></card-preview></td>
                        </tr>
                        <tr>
                            <td><strong>Amount</strong></td>
                            <td>{{ amount }}.00</td>
                        </tr>
                        </tbody>
                    </table>

                </div>
            </div>
        </modal>
    </div>
</template>

<script type="text/babel">
    import Modal from './../utils/modal.vue';
    import ValidationErrors from './../utils/validation-errors.vue';
    import CardPreview from './card-preview.vue';

    export default {
        components: {
            'modal': Modal,
            'validation-errors': ValidationErrors,
            'card-preview': CardPreview
        },

        props: {
            show: Boolean,
            fundingSource: Object,
            fundsPool: Object,
            amount: Number,
            fee: Number,
            totalAmount: Number,
        },

        data() {
            return {
                saving: false,
                errors: {}
            }
        },

        computed: {
            confirmButtonClass() {
                return 'btn btn-success dusk-confirm'
                    + (this.saving ? ' disabled' : '');
            }
        },

        methods: {
            cancel() {
                this.$emit('cancel');
            },

            save() {
                if (this.saving) {
                    return;
                }

                this.saving = true;

                let payload = {
                    fundsPoolId: this.fundsPool.id,
                    productGroupId: this.fundsPool.productGroupId,
                    fundingSourceId: this.fundingSource.id,
                    amount: this.stripNonNumericCharacters(this.amount),
                    fee: this.fee,
                    totalAmount: this.totalAmount
                }

                this.$http.post(route('billing-setup.add-funds'), payload)
                    .then(() => {
                        sweetAlert.fire(
                            'Success',
                            'Funds Added!',
                            'success'
                        ).then(() => {
                            this.$emit('success');
                        });
                    }).catch(({ status, data }) => {
                        if (status === 422) {
                            this.$emit('showErrors', data);
                        } else if (data.message && data.success === false) {
                            this.$emit('showErrors', data);
                        } else {
                            this.$emit('showErrors', {});
                        }

                        this.saving = false;
                    });
            },

            stripNonNumericCharacters(amount) {
                return Number(amount.replace(/[^0-9\.-]+/g,""));
            },

            showConvenienceFee() {
                return this.featureFlag('billing.show-convenience-fee') === true
            }
        }
    }
</script>
